/* External dependencies */
import { gql } from '@apollo/client';

export const updateUserForManagerMutation = gql`
  mutation updateUserForManager($input: UpdateUserForManagerInput!) {
    updateUserForManager(input: $input) {
      statusMessage
    }
  }
`;
